/**
 * Which days of the window the Engagement axis labels.
 *
 * 20.1.1 §4 plots every day, and the axis cannot label every one of them. Recharts thinned them
 * itself by dropping whichever labels collided, and the window's first day was among the
 * casualties: a chart that began mid-window with nothing to say when the window began. These are
 * chosen instead — the first day, the last, and an even stride between — so the axis always states
 * both ends of what is being shown.
 */
export const AXIS_TICKS = 8;

export const dateTicks = (dates: string[]): string[] => {
  if (dates.length <= AXIS_TICKS) return dates;

  const stride = Math.ceil((dates.length - 1) / (AXIS_TICKS - 1));
  const strided = dates.filter((_, index) => index % stride === 0);
  const last = dates[dates.length - 1];

  return strided.includes(last) ? strided : [...strided, last];
};
